// import * as mutation from '../mutations';
import axios from 'axios';
import withDecrypt from '../../src/withDecrypt';
// import decorators from '../../src/api/decorators';
// import requestService from '../../src/api/services/requestService';
// import { home } from '../../src/api/queries';
// import { doHomePageAction } from '../../src/actions';
// import { actionConstants } from '../../src/constants';

async function fetchAPI(query, { variables, preview } = {}) {
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
    // headers: { 'accessToken': args[0] },
  })
    .then(resp => withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}

export default async function getLatestFilings(ticker, tabCode, subTab, first, offset, preview) {
  const data = await fetchAPI(
    `
    query {
      getLatestFilings (ticker:"${ticker}"){
        ticker
        formType
        docHeading
        filename
        dateFiled
      }
    }
    `,
    { preview }
  )
  return data
}
